"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
/* tslint:disable */
var React = tslib_1.__importStar(require("react"));
var LiveIcon = function (_a) {
    var size = _a.size, props = tslib_1.__rest(_a, ["size"]);
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "0 0 26 12", fill: "currentColor", width: size || '26', height: size || '12' }, props),
        React.createElement("g", { id: "Page-1", stroke: "none", fill: "none", strokeWidth: "1", fillRule: "evenodd" },
            React.createElement("g", { id: "Live-backoffice" },
                React.createElement("path", { id: "Rectangle", fill: "currentColor", d: "M-1.51094415e-15 -7.95673788e-16L26 3.8597913e-15 26 12 1.48839274e-15 12z" }),
                React.createElement("path", { d: "M4.81,9 L8.347,9 L8.347,8.334 L5.557,8.334 L5.557,2.997 L4.81,2.997 L4.81,9 Z M9.4,9 L10.147,9 L10.147,2.997 L9.4,2.997 L9.4,9 Z M13.342,9 L14.269,9 L16.69,2.997 L15.835,2.997 L13.81,8.181 L11.785,2.997 L10.93,2.997 L13.342,9 Z M17.473,9 L21.406,9 L21.406,8.334 L18.22,8.334 L18.22,6.264 L21.343,6.264 L21.343,5.598 L18.22,5.598 L18.22,3.663 L21.406,3.663 L21.406,2.997 L17.473,2.997 L17.473,9 Z", id: "LIVE", fill: "currentColor" })))));
};
LiveIcon.displayName = 'LiveIcon';
exports.default = LiveIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=LiveIcon.js.map